import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { usePlanillaDetail } from '../../hooks/usePlanillas';
import { useAuthStore } from '../../stores/auth-store';
import { Skeleton } from '../../components/ui/Skeleton';

/**
 * Smart redirect: resolves the correct planilla page based on current user role + planilla state.
 * Used by notification links so every role lands on the right page.
 */
export function PlanillaRedirectPage() {
  const { planillaId } = useParams<{ planillaId: string }>();
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const { data, isLoading, isError } = usePlanillaDetail(planillaId!);

  useEffect(() => {
    if (!data || !user) return;

    const planilla = data;
    const role = user.role;

    if (role === 'compras' && planilla.estado === 'pendiente_compras') {
      navigate(`/compras/planillas/${planilla.id}/descuentos`, { replace: true });
    } else {
      navigate(`/proyectos/${planilla.project_id}/planillas/${planilla.id}`, { replace: true });
    }
  }, [data, user, navigate]);

  if (isError) {
    return (
      <div className="p-8 text-center text-gray-500">
        No se pudo cargar la planilla.
      </div>
    );
  }

  return (
    <div className="space-y-4 p-6">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-24 w-full" />
      <Skeleton className="h-24 w-full" />
    </div>
  );
}
